export function FlagModels() {
  // 备注标记：1-红色，2-黄色，3-绿色，4-蓝色，5-紫色
  // 备注标记(根据支付宝后台来)：1-蓝色，2-紫色，3-绿色，4-黄色，5-红色
  const qiTitles = [
    { id: 0, title: '灰旗', color: '#dcdee1' },
    { id: 1, title: '蓝旗', color: '#846bff' },
    { id: 2, title: '紫旗', color: '#49cee5' },
    { id: 3, title: '绿旗', color: '#3bc480' },
    { id: 4, title: '黄旗', color: '#ff8933' },
    { id: 5, title: '红旗', color: '#ff616e' },
  ]
  return qiTitles
}


export function GetFlagModel(flagTitle) {
  if (!flagTitle) flagTitle = ""
  flagTitle = flagTitle.replace("色", "旗")
  var item2 = null
  var ls = FlagModels()
  ls.map((item) => {
    if (item.title == flagTitle) item2 = item
  })
  if (!item2) item2 = ls[0]
  return item2
}